import { render, staticRenderFns } from "./MultiLocationSettings.vue?vue&type=template&id=61981a50"
import script from "./MultiLocationSettings.vue?vue&type=script&lang=ts"
export * from "./MultiLocationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports